if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector');
			if ( ! qty ) return;

			const qtyMinus = this.querySelector('.qty-minus');
			const qtyPlus = this.querySelector('.qty-plus');
			if ( ! qtyMinus || ! qtyPlus ) return;

			const qtyMin = qty.hasAttribute('data-min-qty')
				? parseInt(qty.getAttribute('data-min-qty'), 10)
				: (qty.getAttribute('min') ? parseInt(qty.getAttribute('min'), 10) : 1);
			const qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max'), 10) : 9999;
			const rawStep = qty.hasAttribute('data-qty-multiple')
				? parseInt(qty.getAttribute('data-qty-multiple'), 10)
				: (qty.getAttribute('step') ? parseInt(qty.getAttribute('step'), 10) : 1);
			const qtyStep = Number.isFinite(rawStep) && rawStep > 1 ? rawStep : 1;

			let effectiveMin = Number.isFinite(qtyMin) ? qtyMin : 1;
			if ( qtyStep > 1 ) {
				effectiveMin = Math.max(effectiveMin, qtyStep);
				if ( effectiveMin % qtyStep !== 0 ) {
					effectiveMin = Math.ceil(effectiveMin / qtyStep) * qtyStep;
				}
			}

			const emitQtyChange = () => {
				qty.dispatchEvent(new Event('input', { bubbles: true }));
				qty.dispatchEvent(new Event('change', { bubbles: true }));
			};

			const syncDisabled = () => {
				const currentQty = parseInt(qty.value, 10) || 0;
				qtyMinus.classList.toggle('disabled', currentQty - qtyStep < effectiveMin);
				qtyPlus.classList.toggle('disabled', currentQty + qtyStep > qtyMax);
			};

			const nextDown = (currentQty) => {
				if ( qtyStep <= 1 ) {
					return Math.max(effectiveMin, currentQty - 1);
				}
				if ( currentQty % qtyStep === 0 ) {
					return Math.max(effectiveMin, currentQty - qtyStep);
				}
				return Math.max(effectiveMin, Math.floor(currentQty / qtyStep) * qtyStep);
			};

			const nextUp = (currentQty) => {
				if ( qtyStep <= 1 ) {
					return Math.min(qtyMax, currentQty + 1);
				}
				if ( currentQty % qtyStep === 0 ) {
					return Math.min(qtyMax, currentQty + qtyStep);
				}
				return Math.min(qtyMax, Math.ceil(currentQty / qtyStep) * qtyStep);
			};

			syncDisabled();

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( qtyMinus.classList.contains('disabled') ) return;
				const currentQty = parseInt(qty.value, 10) || 0;
				const newQty = nextDown(currentQty);
				if ( newQty !== currentQty ) {
					qty.value = newQty;
					emitQtyChange();
				}
				syncDisabled();
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( qtyPlus.classList.contains('disabled') ) return;
				const currentQty = parseInt(qty.value, 10) || 0;
				const newQty = nextUp(currentQty);
				if ( newQty !== currentQty ) {
					qty.value = newQty;
					emitQtyChange();
				}
				syncDisabled();
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
